import React, { Component } from "react";

import axios from "axios";

import schema from "./schema";
import { DOMAIN } from "config/config";

import Formizo from "Components/LabIZO/Formizo";
import { VStack } from "Components/LabIZO/Stackizo";
import { Accessor, ErrorX, store } from "static";
import { DATA_LINK } from "connectors";

class SysAnswerReviewSetting extends Component {
  static propTypes = {};

  static defaultProps = {};

  constructor() {
    super();
    this.state = {
      SettingDoc: undefined,
    };
  }

  componentDidMount() {
    this._setAllStates(() => {
      this._getSetting();
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (!Accessor.IsIdentical(prevProps, this.props, Object.keys(SysAnswerReviewSetting.defaultProps))) {
      this._setAllStates();
    }
  }

  componentWillUnmount() {
    this.setState = (state, callback) => {
      return;
    };
  }

  _setAllStates = (callback) => {
    this.setState(
      (state, props) => ({
        ...props,
      }),
      callback
    );
  };

  Setting = {
    _onSubmit: async (data) => {
      let SettingLink = "/Config/AnswerReview/Edit";
      let SettingUrl = DOMAIN + SettingLink;

      //change config items to number it it is string
      let cleanedSetAnswerReview = JSON.parse(JSON.stringify(data.SettingDoc));
      if (cleanedSetAnswerReview && cleanedSetAnswerReview.config) {
        const config = cleanedSetAnswerReview.config;
        if (config) {
          // make config is not undefined 或 null
          Object.keys(config).forEach((key) => {
            const category = config[key];
            if (category && typeof category === "object") {
              Object.keys(category).forEach((innerKey) => {
                if (typeof category[innerKey] === "string") {
                  category[innerKey] = parseInt(category[innerKey]);
                }
              });
            } else if (typeof category === "string") {
              config[key] = parseInt(category);
            }
          });
        }
      }

      let SettingPayloadOut = {
        SetAnswerReview: cleanedSetAnswerReview,
        JWT: store.user.JWT,
      };

      console.log("SettingPayloadOut", SettingPayloadOut);

      try {
        store.isLoading(true);
        let res = await axios.post(SettingUrl, SettingPayloadOut);
        store.isLoading(false);

        if (res.data.Success) {
          this.Setting.onSuccess();
        } else {
          this.Setting.onFail("System message update fails.");
        }
      } catch (e) {
        this.Setting.onFail(ErrorX.Handle(e));
      }
    },

    onSuccess: () => {
      store.Alert("System message updated successfully", "success");
      this._getSetting();
    },

    onFail: (msg) => {
      store.isLoading(false);
      store.Alert(msg, "error");
    },
  };

  _getSetting = async () => {
    let link = "/Config/AnswerReview/Edit";
    let url = DOMAIN + link;

    let payloadOut = {
      JWT: store.user.JWT,
    };

    try {
      store.isLoading(true);
      let res = await axios.post(url, payloadOut);
      store.isLoading(false);

      let { Success, payload } = res.data;

      let SettingDoc = {
        SettingDoc: payload,
      };

      if (Success) {
        this.setState({
          SettingDoc: SettingDoc,
        });
      } else {
        store.Alert(payload, "error");
      }
    } catch (e) {
      ErrorX.Handle(e);
    }
  };

  renderForm() {
    let { SettingDoc } = this.state;
    if (SettingDoc === undefined) return;

    let defaultValue = {
      ...SettingDoc,
    };
    return <Formizo height="100%" schema={schema.AnswerReviewSetting} buttons={["Revert", "Submit"]} onSubmit={this.Setting._onSubmit} defaultValue={defaultValue} />;
  }

  render() {
    return <VStack height="100%">{this.renderForm()}</VStack>;
  }
}

export default SysAnswerReviewSetting;
